import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../contexts/ThemeContext';

const ForbiddenPage: React.FC = () => {
  const { colors } = useTheme();
  const { t } = useTranslation('common');

  return (
    <div className={`min-h-[50vh] flex flex-col items-center justify-center px-4 ${colors.text}`}>
      <h1 className="text-2xl font-semibold mb-2">
        {t('errors.forbiddenTitle', { defaultValue: 'Access denied' })}
      </h1>
      <p className={`mb-6 ${colors.textSecondary}`}>
        {t('errors.forbiddenMessage', { defaultValue: 'You do not have permission to view this page.' })}
      </p>
      <Link to="/" className="text-indigo-600 hover:underline dark:text-indigo-400">
        {t('actions.backToHome', { defaultValue: 'Back to home' })}
      </Link>
    </div>
  );
};

export default ForbiddenPage;
